let ingredientsAccordionInitialised = false;

document.addEventListener('DOMContentLoaded', function(){
  let link = document.querySelector(".readmore-link");
  if(link && ingredientsAccordionInitialised === false) {
    link.addEventListener("click", function(e) {
      var isExpanded = e.target.classList.contains("readmore-link--expanded");
      if (!isExpanded) {
        document.querySelector(".accordion--product.is--active .expander-body").classList.add("expanded-height");
        e.target.classList.add("readmore-link--expanded");
      } else {
        document.querySelector(".readmore-link.readmore-link--expanded").classList.remove("readmore-link--expanded");
        document.querySelector(".accordion--product.is--active .expander-body").classList.remove("expanded-height");
        e.target.classList.remove("readmore-link--expanded");
      }
    });
    ingredientsAccordionInitialised = true;
  }
});